export const FAQ_ARTICLES = [
  {
    slug: 'vit-gpa-formula-ffcs-3-2',
    title: 'VIT GPA Formula Under FFCS Academic Regulations 3.2',
    summary: 'Semester GPA is calculated as a credit-weighted average of grade points in registered courses.',
    content: [
      'Under FFCS Academic Regulations Version 3.2, GPA is a weighted average based on course credits and grade points.',
      'For each registered course, multiply Credits (Ci) by Grade Point (GP), then divide by total registered credits in that semester.',
      'This method makes high-credit courses influence GPA more strongly than low-credit courses.'
    ]
  },
  {
    slug: 'vit-cgpa-formula-ffcs-3-2',
    title: 'How VIT Calculates CGPA (FFCS Regulations 3.2)',
    summary: 'CGPA is calculated using all registered courses from first semester to current semester as a weighted average.',
    content: [
      'VIT defines CGPA as overall performance from joining semester up to a specific semester.',
      'It is computed using credit-weighted grade points across all registered courses over semesters.',
      'If a course is failed and repeated multiple times, credits are counted once in numerator and denominator as per regulation text.'
    ]
  },
  {
    slug: 'vit-cgpa-to-percentage-rule',
    title: 'VIT CGPA to Percentage Conversion Rule',
    summary: 'As per regulations, equivalent percentage is CGPA multiplied by 10.',
    content: [
      'Version 3.2 explicitly states percentage equivalence as CGPA x 10.',
      'Example from regulation context: CGPA 8.75 corresponds to 87.5 percent.',
      'Students can request obligatory certificates for CGPA-percentage equivalence through official channels.'
    ]
  },
  {
    slug: 'vit-grading-system-s-to-f',
    title: 'VIT Grading System: S, A, B, C, D, E, F',
    summary: 'VIT uses a 10-point letter-grade system where S is highest and F is fail.',
    content: [
      'Annexure VI of FFCS Regulations 3.2 lists grade points as S=10, A=9, B=8, C=7, D=6, E=5, F=0.',
      'Grades S to E indicate pass in course, while F indicates failure under prescribed conditions.',
      'These grade points are the direct inputs used by GPA and CGPA formulas.'
    ]
  },
  {
    slug: 'what-does-n1-n2-n3-n4-mean-vit',
    title: 'What Do N1, N2, N3, N4 Grades Mean in VIT?',
    summary: 'N grades represent specific non-clearance conditions such as component failure, attendance debarring, FAT absence, or malpractice debarring.',
    content: [
      'N1 indicates failure to clear one or more course components.',
      'N2 indicates debarred status due to lack of attendance, while N3 indicates absence in FAT.',
      'N4 indicates FAT debarment due to indiscipline or malpractice, as defined in grading annexure.'
    ]
  },
  {
    slug: 'difference-between-f-and-n-grade-vit',
    title: 'Difference Between F Grade and N Grade in VIT',
    summary: 'F and N both indicate non-clearance, but they arise from different academic conditions.',
    content: [
      'F typically reflects not meeting minimum performance requirements or specific indiscipline outcomes defined for grading.',
      'N is condition-based (component not cleared, attendance shortage, FAT absence, or FAT debarment).',
      'Both should be addressed through permitted re-registration, arrear, or supplementary pathways where applicable.'
    ]
  },
  {
    slug: 'are-audit-minor-honours-counted-in-gpa-vit',
    title: 'Are Audit, Minor, and Honours Courses Counted in VIT GPA/CGPA?',
    summary: 'Audit, Minor, and Honours courses are not counted toward GPA/CGPA of the main programme.',
    content: [
      'Regulations state pass-fail and audit courses are excluded from GPA/CGPA computation.',
      'Minor and Honours credits are shown separately as credentials and do not alter core programme GPA/CGPA.',
      'This is important while forecasting GPA/CGPA in calculators.'
    ]
  },
  {
    slug: 'does-failed-course-count-in-cgpa-vit',
    title: 'Does an F Grade Course Count in VIT CGPA Calculation?',
    summary: 'Regulations include registered courses, including F grades, in GPA/CGPA calculation logic.',
    content: [
      'Version 3.2 states that i includes all registered courses in all semesters, including those with F grade.',
      'This is why unresolved backlogs can keep CGPA lower until cleared and replaced as per policy treatment.',
      'Accurate semester-wise credit history is necessary for realistic CGPA planning.'
    ]
  },
  {
    slug: 'vit-gpa-cgpa-rounding-rule',
    title: 'VIT GPA/CGPA Rounding Rule (Two Decimals)',
    summary: 'GPA and CGPA are indicated up to two decimal places in grade sheets.',
    content: [
      'Regulations indicate GPA and CGPA are reported at two decimal places.',
      'Use consistent two-decimal display for comparison with semester and consolidated grade sheets.',
      'Avoid early rounding during intermediate calculations to reduce drift in estimates.'
    ]
  },
  {
    slug: 'vit-exam-eligibility-cat-fat',
    title: 'VIT Exam Eligibility for CAT and FAT',
    summary: 'Registered students are eligible for CAT/FAT unless debarred for attendance, indiscipline, or course withdrawal.',
    content: [
      'Eligibility section lists major debarment reasons: shortage of attendance, indiscipline, and course withdrawal.',
      'Even when registered, these conditions can block CAT/FAT participation in that course.',
      'Maintain attendance and regulation compliance before exam windows.'
    ]
  },
  {
    slug: 'vit-attendance-rule-75-percent',
    title: 'VIT Attendance Rule: Minimum 75 Percent Requirement',
    summary: 'VIT expects full attendance but allows up to 25 percent absence, requiring at least 75 percent attendance.',
    content: [
      'Regulations state students are expected to maintain 100 percent attendance.',
      'A minimum of 75 percent attendance is required in each course for exam eligibility.',
      'Attendance shortage can lead to N2 outcomes and exam debarment implications.'
    ]
  },
  {
    slug: 'vit-add-drop-window',
    title: 'VIT Add/Drop Window: First Three Instructional Days',
    summary: 'Add/Drop is allowed in regular semesters during first three instructional days, subject to limits.',
    content: [
      'The add/drop option is available for initially registered courses in regular semesters.',
      'It must be completed within the first three instructional days and within min-max credit constraints.',
      'Dropped courses do not appear in that semester grade sheet.'
    ]
  },
  {
    slug: 'vit-course-withdrawal-what-happens',
    title: 'VIT Course Withdrawal: What It Means for Students',
    summary: 'Course withdrawal is a regulated option and differs from add/drop and failure grading outcomes.',
    content: [
      'Course withdrawal follows a separate process defined under registration regulations.',
      'It is used when performance or circumstances require dropping progression in that specific course.',
      'Students should check timing and effect on grade sheet entries before opting.'
    ]
  },
  {
    slug: 'vit-absence-in-cat-fat-supplementary',
    title: 'What If You Miss CAT or FAT in VIT? Supplementary Rules',
    summary: 'Missing CAT generally loses that weightage; supplementary exams are restricted to approved cases.',
    content: [
      'Regulations indicate no general re-CAT for absence; weightage may be lost unless supplementary CAT is approved.',
      'Supplementary FAT can be considered under extraordinary documented cases within prescribed timelines.',
      'If approved supplementary schedules are missed, the student must clear through re-registration pathways.'
    ]
  },
  {
    slug: 'vit-academic-malpractice-penalty',
    title: 'VIT Academic Malpractice Penalties Under FFCS',
    summary: 'Academic malpractice is treated seriously, with penalties that can affect multiple registered courses.',
    content: [
      'Regulation text specifies strong penalties for malpractice during assessments.',
      'For FAT malpractice cases, penalties can extend to regular courses attended in that semester.',
      'Such outcomes may result in N grades and later re-registration requirements.'
    ]
  },
  {
    slug: 'vit-promotion-cgpa-below-4',
    title: 'Promotion Rule in VIT and CGPA Below 4.00',
    summary: 'Students are promoted semester-wise, but CGPA below 4.00 can restrict future credit load.',
    content: [
      'Promotion is generally automatic semester-to-semester irrespective of immediate performance.',
      'However, regulations cap future registration to a maximum credit limit when CGPA goes below 4.00.',
      'Students are expected to recover performance while clearing pending courses.'
    ]
  },
  {
    slug: 'vit-arrear-exam-vs-reregistration',
    title: 'VIT Arrear Examination vs Re-Registration',
    summary: 'Students may clear backlogs through arrear exams or switch back to re-registration as permitted.',
    content: [
      'Arrear option allows backlog clearance attempts without a fixed attempt cap under stated conditions.',
      'If arrear route does not produce pass grade, students may switch to re-registration.',
      'Internal marks and challenge-50 treatment are defined in arrear regulation clauses.'
    ]
  },
  {
    slug: 'vit-grade-improvement-rules',
    title: 'VIT Grade Improvement Rules (How Many Courses and Attempts)',
    summary: 'Grade improvement is allowed with limits on frequency and number of courses per semester.',
    content: [
      'Students can register the same course again to improve grade, subject to rule limits.',
      'Only one grade-improvement course per semester is generally allowed, with special flexibility for graduating/timed-out cases.',
      'Course fee applies for grade improvement registrations.'
    ]
  },
  {
    slug: 'vit-credit-registration-limits',
    title: 'VIT Minimum and Maximum Credit Limits for Registration',
    summary: 'Credit registration is controlled by semester rules, CGPA status, and special-term constraints.',
    content: [
      'Regulations specify min-max credit boundaries in regular and special terms.',
      'Students with low CGPA can be advised or restricted to lower maximum loads.',
      'Always plan credits with proctor guidance before registration windows close.'
    ]
  },
  {
    slug: 'vit-time-limit-programme-completion',
    title: 'VIT Time Limit for Programme Completion (n+3 Rule)',
    summary: 'Students must complete programme requirements within minimum duration plus allowed grace period.',
    content: [
      'Regulations define programme-specific minimum duration (n) and additional grace period provisions.',
      'Beyond the permitted completion window, studentship cancellation rules apply automatically.',
      'Backlogs should be planned early to avoid reaching the final time-limit boundary.'
    ]
  }
];

export const FAQ_SCHEMA_ITEMS = FAQ_ARTICLES.map((article) => ({
  '@type': 'Question',
  name: article.title,
  acceptedAnswer: {
    '@type': 'Answer',
    text: article.summary
  }
}));
